import Tabs from "@/components/Tabs";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const { applicationId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const currentUrl = location.pathname.replace(/\/$/, "");

  if (!applicationId) return null;

  const basePath = `/people/membership-services/applications/${applicationId}`;

  return (
    <>
      <Tabs
        tabItems={[
          {
            label: "Overview",
            active: currentUrl === `${basePath}/overview`,
            onClick: () => navigate(`${basePath}/overview`)
          },
          {
            label: "Application Details",
            active: currentUrl === `${basePath}/details`,
            onClick: () => navigate(`${basePath}/details`)
          },
          {
            label: "Notes and Tasks",
            active: currentUrl === `${basePath}/notes`,
            onClick: () => navigate(`${basePath}/notes`)
          }
        ]}
      />
      <div className="flex flex-col min-w-0">{children}</div>
    </>
  );
}
